<!-- Design reminder: Preserve Zynem’s established Vuetify shell; the new Industries menu uses the existing navy navigation and white dropdown language. -->
<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <router-link to="/" class="d-flex align-center" style="text-decoration: none;">
        <v-img
          alt="Zynem Consulting Logo"
          class="shrink mr-2"
          contain
          src="/zyn_white.png"
          transition="scale-transition"
          width="290"
          height="120"
        />
      </router-link>

      <v-spacer></v-spacer>

      <div class="desktop-navigation d-none d-md-flex align-center">
      <v-btn
        v-for="item in leftMenuItems"
        :key="item.title"
        :to="item.path"
        text
        class="mx-1"
      >
        {{ item.title }}
      </v-btn>

      <v-menu transition="scale-transition" location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn text class="mx-1" v-bind="props">
            Solutions
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list class="solutions-menu" min-width="288">
          <v-list-subheader class="text-primary font-weight-bold">ZYNEM SOLUTIONS</v-list-subheader>
          <v-list-item
            v-for="item in solutionsMenuItems"
            :key="item.title"
            :to="item.path"
            :prepend-icon="item.icon"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            <v-list-item-subtitle v-if="item.subtitle">{{ item.subtitle }}</v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu transition="scale-transition" location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn text class="mx-1" v-bind="props">
            Industries
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list class="industries-menu" min-width="300">
          <v-list-subheader class="text-primary font-weight-bold">INDUSTRY SOLUTIONS</v-list-subheader>
          <v-list-item
            v-for="item in industriesMenuItems"
            :key="item.title"
            :to="item.path"
            :prepend-icon="item.icon"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn text class="mx-1" v-bind="props">
            Resources
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
          <v-list>
            <v-list-item
              v-for="item in resourcesMenuItems"
              :key="item.title"
              :to="item.path"
              :prepend-icon="item.icon"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn
        v-for="item in rightMenuItems"
        :key="item.title"
        :to="item.path"
        text
        class="mx-1"
      >
        {{ item.title }}
      </v-btn>
      
      <!-- Admin Menu - Only visible when logged in -->
      <v-menu v-if="isAdmin">
        <template v-slot:activator="{ props }">
          <v-btn
            icon
            v-bind="props"
            class="ml-2"
            title="Admin"
          >
            <v-icon>mdi-shield-account</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/admin/blog">
            <template v-slot:prepend>
              <v-icon>mdi-post</v-icon>
            </template>
            <v-list-item-title>Blog Management</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <template v-slot:prepend>
              <v-icon>mdi-logout</v-icon>
            </template>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      
      <!-- Login icon removed as requested -->
      </div>

      <v-btn
        icon
        class="d-md-none"
        aria-label="Open navigation menu"
        title="Open navigation menu"
        @click="mobileNav = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-model="mobileNav"
      class="mobile-navigation d-md-none"
      location="right"
      temporary
      width="320"
    >
      <div class="mobile-navigation__header pa-5 d-flex align-center">
        <router-link to="/" class="d-flex align-center" style="text-decoration: none;" @click="closeMobileNav">
          <v-img alt="Zynem Consulting" contain src="/zyn_white.png" width="154" height="52" />
        </router-link>
        <v-spacer></v-spacer>
        <v-btn icon="mdi-close" variant="text" aria-label="Close navigation menu" title="Close navigation menu" @click="closeMobileNav"></v-btn>
      </div>

      <v-divider></v-divider>

      <v-list nav density="comfortable" class="px-3 py-4">
        <v-list-item
          v-for="item in leftMenuItems"
          :key="`mobile-${item.title}`"
          :to="item.path"
          :prepend-icon="item.icon"
          :title="item.title"
          @click="closeMobileNav"
        ></v-list-item>

        <v-list-group value="solutions">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" prepend-icon="mdi-view-grid-outline" title="Solutions"></v-list-item>
          </template>
          <v-list-item
            v-for="item in solutionsMenuItems"
            :key="`mobile-${item.title}`"
            :to="item.path"
            :prepend-icon="item.icon"
            :title="item.title"
            :subtitle="item.subtitle"
            @click="closeMobileNav"
          ></v-list-item>
        </v-list-group>

        <v-list-group value="industries">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" prepend-icon="mdi-domain" title="Industries"></v-list-item>
          </template>
          <v-list-item
            v-for="item in industriesMenuItems"
            :key="`mobile-${item.title}`"
            :to="item.path"
            :prepend-icon="item.icon"
            :title="item.title"
            @click="closeMobileNav"
          ></v-list-item>
        </v-list-group>

        <v-list-group value="resources">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" prepend-icon="mdi-folder-outline" title="Resources"></v-list-item>
          </template>
          <v-list-item
            v-for="item in resourcesMenuItems"
            :key="`mobile-${item.title}`"
            :to="item.path"
            :prepend-icon="item.icon"
            :title="item.title"
            @click="closeMobileNav"
          ></v-list-item>
        </v-list-group>

        <v-divider class="my-3"></v-divider>

        <v-list-item
          v-for="item in rightMenuItems"
          :key="`mobile-${item.title}`"
          :to="item.path"
          :prepend-icon="item.icon"
          :title="item.title"
          @click="closeMobileNav"
        ></v-list-item>

        <v-list-item v-if="isAdmin" prepend-icon="mdi-post" title="Blog Management" to="/admin/blog" @click="closeMobileNav"></v-list-item>
        <v-list-item v-if="isAdmin" prepend-icon="mdi-logout" title="Logout" @click="logoutFromMobile"></v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>

    <v-footer color="primary" dark padless>
      <v-container>
        <v-row>
          <v-col cols="12" md="12" lg="3">
            <router-link to="/" style="text-decoration: none;">
              <v-img
                alt="Zynem Consulting"
                contain
                class="shrink mr-2"
                src="/zyn_white.png"
                transition="scale-transition"
                width="200"
                height="180"
              />
            </router-link>
            <p class="text-body-2">Advanced Microsoft Dynamics AX integration solutions that optimize operations and foster significant enterprise growth.</p>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="2">
            <h3 class="text-h6 mb-4">Services</h3>
            <v-list density="compact" bg-color="transparent" color="white">
              <v-list-item to="/services/crm">CRM Solutions</v-list-item>
              <v-list-item to="/services/field-service">Field Service</v-list-item>
              <v-list-item to="/services/mobile-integration">Mobile Integration</v-list-item>
              <v-list-item to="/services/server-migration">Server Migration</v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="2">
            <h3 class="text-h6 mb-4">Solutions</h3>
            <v-list density="compact" bg-color="transparent" color="white">
              <v-list-item v-for="item in solutionsMenuItems" :key="item.title" :to="item.path">
                {{ item.title }}
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="2">
            <h3 class="text-h6 mb-4">Industries</h3>
            <v-list density="compact" bg-color="transparent" color="white">
              <v-list-item v-for="item in industriesMenuItems" :key="item.title" :to="item.path">
                {{ item.title }}
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="3">
            <v-row>
              <v-col cols="6">
                <h3 class="text-h6 mb-4">Resources</h3>
                <v-list density="compact" bg-color="transparent" color="white">
                  <v-list-item v-for="item in resourcesMenuItems" :key="item.title" :to="item.path">
                    {{ item.title }}
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="6">
                <h3 class="text-h6 mb-4">Company</h3>
                <v-list density="compact" bg-color="transparent" color="white">
                  <v-list-item to="/about">About Us</v-list-item>
                  <v-list-item to="/contact">Contact</v-list-item>
                  <!-- Blog Management link only visible to admins -->
                  <v-list-item v-if="isAdmin" to="/admin/blog">Blog Management</v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        
        <v-divider class="my-4" color="rgba(255,255,255,0.2)"></v-divider>
        
        <div class="text-center text-body-2">
          &copy; {{ new Date().getFullYear() }} Zynem Consulting. All rights reserved.
        </div>
      </v-container>
    </v-footer>
    
    <!-- Snackbar for notifications -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
    >
      {{ snackbar.text }}
      <template v-slot:actions>
        <v-btn
          variant="text"
          icon="mdi-close"
          @click="snackbar.show = false"
        ></v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import authService from '@/services/authService';

export default {
  name: 'App',
  data() {
    return {
      leftMenuItems: [
        { title: 'Home', path: '/', icon: 'mdi-home-outline' },
        { title: 'Services', path: '/services', icon: 'mdi-briefcase-outline' },
      ],
      solutionsMenuItems: [
        { title: 'zynAccounting', path: '/solutions/zynaccounting', icon: 'mdi-calculator-variant-outline', subtitle: 'Finance operations around Dynamics AX' },
        { title: 'zynAgentics', path: '/solutions/zynagentics', icon: 'mdi-robot-outline', subtitle: 'Agentic workspace · under development' },
      ],
      industriesMenuItems: [
        { title: 'Distribution', path: '/industries/distribution', icon: 'mdi-truck-fast-outline' },
        { title: 'Nonprofit', path: '/industries/nonprofit', icon: 'mdi-hand-heart-outline' },
        { title: 'Manufacturing', path: '/industries/manufacturing', icon: 'mdi-factory' },
        { title: 'Professional Services', path: '/industries/professional-services', icon: 'mdi-briefcase-account-outline' },
        { title: 'E-commerce', path: '/industries/ecommerce', icon: 'mdi-cart-outline' },
        { title: 'Healthcare', path: '/industries/healthcare', icon: 'mdi-heart-pulse' },
        { title: 'Education', path: '/industries/education', icon: 'mdi-school-outline' },
      ],
      resourcesMenuItems: [
        { title: 'Blog', path: '/blog', icon: 'mdi-post-outline' },
      ],
      rightMenuItems: [
        { title: 'About', path: '/about', icon: 'mdi-account-circle-outline' },
        { title: 'Contact', path: '/contact', icon: 'mdi-email-outline' },
      ],
      mobileNav: false,
      isAdmin: false,
      isAuthenticated: false,
      snackbar: {
        show: false,
        text: '',
        color: 'success'
      }
    }
  },
  created() {
    // Check authentication status
    this.checkAuthStatus();
    
    // Listen for auth events
    window.addEventListener('storage', this.handleStorageChange);
  },
  beforeUnmount() {
    // Remove event listener
    window.removeEventListener('storage', this.handleStorageChange);
  },
  methods: {
    checkAuthStatus() {
      this.isAuthenticated = authService.isAuthenticated();
      this.isAdmin = authService.isAdmin();
    },
    logout() {
      authService.logout();
      this.isAuthenticated = false;
      this.isAdmin = false;
      
      this.snackbar = {
        show: true,
        text: 'You have been logged out',
        color: 'info'
      };
      
      // Redirect to home if on admin page
      if (this.$route.path.startsWith('/admin')) {
        this.$router.push('/');
      }
    },
    closeMobileNav() {
      this.mobileNav = false;
    },
    logoutFromMobile() {
      this.closeMobileNav();
      this.logout();
    },
    handleStorageChange(event) {
      // Update auth status if auth_token changes
      if (event.key === 'auth_token' || event.key === 'user_info') {
        this.checkAuthStatus();
      }
    }
  }
}
</script>

<style scoped>
/* Design reminder: Keep desktop and mobile navigation quiet, accessible, and aligned with the established navy header language. */
.desktop-navigation {
  flex-wrap: nowrap;
}

.mobile-navigation {
  background: #ffffff;
}

.mobile-navigation__header {
  min-height: 5.4rem;
  background: #0b2545;
}

.mobile-navigation :deep(.v-list-item) {
  min-height: 3.1rem;
}

.mobile-navigation :deep(.v-list-group__items .v-list-item) {
  padding-left: 2.35rem;
}

.mobile-navigation :deep(.v-list-item-title) {
  color: #0b2545;
  font-weight: 700;
}

.mobile-navigation :deep(.v-list-item-subtitle) {
  color: #62758a;
}

.mobile-navigation :deep(.v-list-group__items .v-list-item-title) {
  font-weight: 600;
}

.industries-menu {
  border: 1px solid rgba(11, 37, 69, 0.1);
  box-shadow: 0 1rem 2rem rgba(11, 37, 69, 0.12);
}

.solutions-menu {
  border: 1px solid rgba(11, 37, 69, 0.1);
  box-shadow: 0 1rem 2rem rgba(11, 37, 69, 0.12);
}
</style>
